import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Paper, Typography } from '@mui/material'
import { CustomContentProps, SnackbarContent, useSnackbar } from 'notistack'
import { forwardRef } from 'react'
import animatedNotificationIcon from '../../Assets/Images/animatedNotification.gif'

declare module 'notistack' {
  interface VariantOverrides {
    snackbarNotification: {
      data: any
      onClickAction: () => void
    }
  }
}

interface SnackbarNotificationProps extends CustomContentProps {
  message: string
  data: any
  onClickAction: () => void
}

export const SnackbarNotification = forwardRef<HTMLDivElement, SnackbarNotificationProps>(
  (props, ref) => {
    const { closeSnackbar } = useSnackbar()
    const { message, data, onClickAction } = props

    return (
      <SnackbarContent ref={ref} id={String(props.id)}>
        <Paper
          elevation={6}
          sx={{
            maxWidth: 420,
            display: 'flex',
            borderRadius: 2,
            flexDirection: 'row',
            alignItems: 'center',
            position: 'relative',
            backgroundColor: '#f4f0fb',
            border: '1px solid #DCDCDC',
            boxShadow: '0px 4px 6px -2px #24242408',
            cursor: 'pointer',
          }}
          onClick={() => {
            closeSnackbar()
            onClickAction()
          }}
          data-testid='snackbar-notification'
        >
          <Box
            sx={{
              height: '100%',
              background: '#fff',
              borderTopLeftRadius: '8px',
              borderBottomLeftRadius: '8px',
              display: 'flex',
              padding: '10px 24px 10px 24px',
              borderRight: '1px solid #DCDCDC',
              alignItems: 'center',
            }}
          >
            <img className='ml-auto mr-auto' src={animatedNotificationIcon} height={35} />
          </Box>

          <Box height={'100%'} p={'10px 16px 10px 10px'}>
            <IconButton
              size='small'
              onClick={(e) => {
                e.stopPropagation()
                closeSnackbar(props.id)
              }}
              sx={{ position: 'absolute', right: 8, mt: '-5px', alignItems: 'center' }}
            >
              <CloseIcon fontSize='small' />
            </IconButton>
            <Typography
              fontWeight={600}
              fontSize={14}
              mb={0.5}
              mr={2.5}
              width={'295px'}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                fontFamily: 'Inter,sans-serif',
              }}
            >
              {message}
            </Typography>
            <Typography
              fontWeight={400}
              fontSize={14}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                fontWeight: '400',
                fontFamily: 'Inter,sans-serif',
              }}
            >
              {data?.message || ''}
            </Typography>
          </Box>
        </Paper>
      </SnackbarContent>
    )
  },
)
SnackbarNotification.displayName = 'SnackbarNotification'
